import React from "react";
import MarketplaceTabComponent from "./marketplaceTab.component";

export default function MarketplaceTabContainer(props) {
  return <MarketplaceTabComponent {...props} />;
}
